import { useRef, useState } from "react";

interface Props {
  before: string;
  after: string;
  height?: string;
}

export default function BeforeAfter({ before, after, height = "h-[260px] sm:h-[380px] lg:h-[560px]" }: Props) {
  const [pos, setPos] = useState(50);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const dragging = useRef(false);

  const move = (clientX: number) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = clientX - rect.left;
    const pct = Math.min(100, Math.max(0, (x / rect.width) * 100));
    setPos(pct);
  };

  return (
    <div
      ref={containerRef}
      className={`relative w-full ${height} rounded-2xl overflow-hidden select-none bg-neutral-100`}
      onMouseDown={(e) => {
        dragging.current = true;
        move(e.clientX);
      }}
      onMouseMove={(e) => dragging.current && move(e.clientX)}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onTouchStart={(e) => move(e.touches[0].clientX)}
      onTouchMove={(e) => move(e.touches[0].clientX)}
    >
      {/* After (base) */}
      <img
        src={after}
        alt="시공 후"
        className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none"
      />
      <div className="absolute top-5 right-5 px-4 py-1.5 rounded-full bg-point-500 text-white text-xs font-semibold z-30">
        AFTER
      </div>

      {/* Before (clipped) */}
      <div
        className="absolute inset-0 overflow-hidden pointer-events-none"
        style={{ width: `${pos}%` }}
      >
        <img
          src={before}
          alt="시공 전"
          className="absolute inset-0 w-full h-full object-cover object-center"
          style={{ width: containerRef.current?.clientWidth ?? "100%" }}
        />
        <div className="absolute top-5 left-5 px-4 py-1.5 rounded-full bg-navy-900 text-white text-xs font-semibold">
          BEFORE
        </div>
      </div>

      {/* Divider */}
      <div
        className="absolute top-0 bottom-0 w-0.5 bg-white z-20 pointer-events-none"
        style={{ left: `calc(${pos}% - 1px)` }}
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white flex items-center justify-center border border-neutral-200">
          <i className="ri-arrow-left-right-line text-xl text-navy-900"></i>
        </div>
      </div>
    </div>
  );
}